export const ADD_RECIPE_DECK = "ADD_RECIPE_DECK";
export const REMOVE_RECIPE_DECK = "REMOVE_RECIPE_DECK";
export const UNSELECT_ALL_RECIPES = "UNSELECT_ALL_RECIPES";

export const SAVE_RECIPE_DECK = "SAVE_RECIPE_DECK";
export const DELETE_RECIPE_DECK = "DELETE_RECIPE_DECK";
export const LOAD_RECIPE_DECK = "LOAD_RECIPE_DECK";

export const SELECT_RECIPE = "SELECT_RECIPE";
export const COMPARE_RECIPES = "COMPARE_RECIPES";
export const STOP_COMPARING = "STOP_COMPARING";

export const INIT_ACTIVE_CLUSTERS = "INIT_ACTIVE_CLUSTERS";

export const TOGGLE_CLUSTER = "TOGGLE_CLUSTER";
export const SELECT_ALL = "SELECT_ALL";
export const UNSELECT_ALL = "UNSELECT_ALL";

export const SAVE_CLUSTER_DECK = "SAVE_CLUSTER_DECK";
export const DELETE_CLUSTER_DECK = "DELETE_CLUSTER_DECK";
export const LOAD_CLUSTER_DECK = "LOAD_CLUSTER_DECK";

export const CHANGE_CLUSTER_RULE = "CHANGE_CLUSTER_RULE";

export const INGREDIENT_INSTRUCTION_COMBO = "INGREDIENT_INSTRUCTION_COMBO";
export const SET_HIGHLIGHT = "SET_HIGHLIGHT";
export const DELETE_HIGHLIGHT = "DELETE_HIGHLIGHT";



// WEBPACK FOOTER //
// ./src/constants/actionTypes.js